<div id="home" class="main-banner item-bg-one">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="main-banner-text">
                    <h1>Centro de Investigaciones en <span>Desarrollo Humano</span></h1>
                    <p>
                        Comprometidos desde 1996 con la innovación, tecnología y el progreso científico/humano.
                    </p>
                    <a (click)="onClick('about')" class="btn btn-primary">Sobre Nosotros</a>
                    <a (click)="onClick('work')" class="btn btn-primary view-work">Nuestro Trabajo</a>
                </div>
            </div>
        </div>
    </div>
</div>

<app-welcome></app-welcome>

<app-about></app-about>

<app-strategy></app-strategy>

<app-who-we-are></app-who-we-are>

<app-funfacts></app-funfacts>

<app-team></app-team>

<app-services></app-services>

<app-why-we-different></app-why-we-different>

<app-work></app-work>

<app-blog></app-blog>

<app-contact></app-contact>
